export default {
  free: 'GRATIS',
  save: 'Risparmia {{amount}}',
};
